module.exports = __webpack_public_path__ + "img/home-105x63.afc84dad.jpg";